/**
 * Lab changePassword form rules — same strength policy as create-downline,
 * plus current/new/confirm checks from Backend-UI changePassword.html.
 */

import {
  PASSWORD_POLICY_MESSAGE,
  confirmPasswordError,
  isPasswordValid,
  passwordChecks,
} from '@/features/hierarchy/passwordPolicy'

export { PASSWORD_POLICY_MESSAGE, isPasswordValid, passwordChecks }

export function currentPasswordError(password: string): string | null {
  if (password.trim() === '') return 'Current Password Required'
  return null
}

export function newPasswordError(password: string, current: string): string | null {
  if (password.trim() === '') return 'New Password Required'
  if (!isPasswordValid(password)) return PASSWORD_POLICY_MESSAGE
  if (current && password === current) return 'Old and New password are same'
  return null
}

export function changeConfirmPasswordError(
  password: string,
  confirm: string,
): string | null {
  if (confirm.trim() === '') return 'Confirm Password Required'
  const mismatch = confirmPasswordError(password, confirm)
  if (mismatch === "Confirm password doesn't match") {
    return 'New and Confirm password are not same'
  }
  return mismatch
}
